import { Box, Typography } from '@mui/material';

import { caloTheme } from '../../assets/themes/calo';
import type { TodayProgress } from '../../libs';
import { chefText, tabular } from '../chefStyles';

const { palette } = caloTheme;

const DOT_SIZE = { xs: 16, md: 20 };

// One dot for each of the day's goal, filled for each one done; the words carry the same count.
const ProgressDots = ({ done, goal }: Pick<TodayProgress, 'done' | 'goal'>) => (
  <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', columnGap: { xs: 1.5, md: 2 }, rowGap: 1 }}>
    <Box aria-hidden sx={{ display: 'flex', gap: 1 }}>
      {Array.from({ length: goal }, (_unused, at) => (
        <Box
          key={at}
          sx={{
            width: DOT_SIZE,
            height: DOT_SIZE,
            borderRadius: '50%',
            boxSizing: 'border-box',
            border: `2px solid ${at < done ? palette.primary.main : palette.neutral700}`,
            backgroundColor: at < done ? palette.primary.main : palette.white
          }}
        />
      ))}
    </Box>
    <Typography sx={{ ...chefText.body, color: palette.neutral800, ...tabular }}>
      {done} of {goal} done
    </Typography>
  </Box>
);

export default ProgressDots;
